import { useEffect, useState, useContext } from "react";

import { translate } from "@utils";

import { ActivePolicyContext } from "@modules/cve/context";

import Alert from "@mui/material/Alert";

import { PolicyFormActionSelect, PolicyFormSeveritiesSelect, PolicyFormTrueOrFalse, PolicyFormLevelsSelect, PolicyFormAddToList, PolicyFormNameInput, PolicyFormSave } from "@modules/cve/components";

export const PolicyForm = ({ viewOnly = false, handleCancel }) => {
	const [inputErrors, setInputErrors] = useState();
	const { activePolicy, setActivePolicy } = useContext(ActivePolicyContext);

	useEffect(() => {
		return setActivePolicy;
	}, []);

	useEffect(() => {
		setInputErrors();
	}, [activePolicy]);

	return (
		<>
			{inputErrors && (
				<div style={{ display: "flex", gap: "50px" }}>
					{inputErrors.map((error) => {
						return (
							<Alert style={{ width: "100%" }} key={error} severity="error">
								${error}
							</Alert>
						);
					})}
				</div>
			)}
			
			{viewOnly ? <h2>{translate("viewPolicy")}</h2> : <h2>{activePolicy?.policyId ? translate("editPolicy") : translate("createPolicy")}</h2>}

			<PolicyFormNameInput viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} />

			<div style={{ display: "flex", gap: "50px", marginTop: "20px" }}>
				<div style={{ display: "flex", flexDirection: "column", gap: "15px", width: "100%" }}>
					<h4>Policy Conditions</h4>
					<div style={{ display: "flex", flexWrap: "wrap", gap: "5px" }}>
						<PolicyFormActionSelect viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} />
						<PolicyFormTrueOrFalse viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} keyName="hasExploit" label={translate("hasExploit")} />
						<PolicyFormTrueOrFalse viewOnly={viewOnly} activePolicy={activePolicy} setActivePolicy={setActivePolicy} keyName="hasPatch" label={translate("hasPatch")} />
					</div>
					<PolicyFormSeveritiesSelect activePolicy={activePolicy} setActivePolicy={setActivePolicy} viewOnly={viewOnly} />
					<PolicyFormAddToList type="vendors" activePolicy={activePolicy} setActivePolicy={setActivePolicy} viewOnly={viewOnly} />
					<PolicyFormAddToList type="products" activePolicy={activePolicy} setActivePolicy={setActivePolicy} viewOnly={viewOnly} />
					<PolicyFormAddToList type="cveIds" activePolicy={activePolicy} setActivePolicy={setActivePolicy} viewOnly={viewOnly} />
				</div>
				<div style={{ display: "flex", flexDirection: "column", gap: "15px", width: "100%" }}>
					<PolicyFormLevelsSelect activePolicy={activePolicy} setActivePolicy={setActivePolicy} viewOnly={viewOnly} />
				</div>
			</div>

			{!viewOnly && <PolicyFormSave handleCancel={handleCancel} activePolicy={activePolicy} setActivePolicy={setActivePolicy} setInputErrors={setInputErrors} />}
		</>
	);
};
